import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { updateName } from '../../../../../../../../store/auth';

import Form from '../../../../../../../../components/Form/Form/';
import LimitedTextArea from '../../../../../../../../components/Form/LimitedTextArea';
import UploadImage from '../../../../../../../../components/Form/UploadPhoto/';
import Spinner from '../../../../../../../../components/Spinner/';
import { validateEmail } from '../../../../../../../../components/Utils/';

import './About.scss';

/* eslint-disable max-len */
const BIOPlaceHolder = 'Caroline is a management consultant at BCG, with broad experience across consumer, retail, financial services, and media sectors. ' +
  'Her background includes marketing, strategy, and e-commerce roles, as well as four years in economic research and consulting.' +
  '\n\nCaroline is passionate about mentorship, and excited to help you navigate your career journey and find the best job, internship, or other experience for you.';
/* eslint-enable max-len */

class About extends React.Component {
  constructor(props, context) {
    super(props, context);

    Bugsnag.leaveBreadcrumb('Advisor loaded about data: ', JSON.stringify(props.AboutUserData.AdvisorProfile, null, 2));

    this.state = {
      changeMade: false,
      saving: false,
      errorFound: false,
      customButtonMessage: null,
      initialValues: props.AboutUserData.AdvisorProfile,
      currentValues: props.AboutUserData.AdvisorProfile,
      validationErrors: {},
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.getButtonText = this.getButtonText.bind(this);
    this.saveUploadedPhoto = this.saveUploadedPhoto.bind(this);
    this.validationError = this.validationError.bind(this);
    this.routerWillLeave = this.routerWillLeave.bind(this);
  }

  componentDidMount() {
    this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
  };

  routerWillLeave(nextLocation) {
    if (this.state.changeMade) {
      return 'Your work is not saved! Are you sure you want to leave?';
    }
  };

  handleChange(event) {
    window.onbeforeunload = function () {
      return true;
    };

    this.setState({
      changeMade: true,
      currentValues: event.target.value,
      customButtonMessage: null,
    });
  }

  validateForm() {
    let hasErrors = false;
    let validationErrors = {};

    if (!this.state.currentValues.first_name) {
      hasErrors = true;
      validationErrors.first_name = 'The First Name field is required.';
    } else {
      validationErrors.first_name = '';
    }

    if (!this.state.currentValues.phone) {
      hasErrors = true;
      validationErrors.phone = 'The Phone number field is required.';
    } else {
      validationErrors.phone = '';
    }

    if (!this.state.currentValues.last_name) {
      hasErrors = true;
      validationErrors.last_name = 'The Last Name field is required.';
    } else {
      validationErrors.last_name = '';
    }

    if (!this.state.currentValues.email) {
      hasErrors = true;
      validationErrors.email = 'The Email field is required.';
    } else if (!validateEmail(this.state.currentValues.email)) {
      hasErrors = true;
      validationErrors.email = 'You must enter a valid email in the Email field.';
    } else {
      validationErrors.email = '';
    }

    if (!this.state.currentValues.linkedin_username) {
      hasErrors = true;
      validationErrors.linkedin_username = 'The LinkedIn Username field is required.';
    } else {
      validationErrors.linkedin_username = '';
    }

    if (!this.state.currentValues.biography) {
      hasErrors = true;
      validationErrors.biography = 'The Biography field is required.';
    } else {
      validationErrors.biography = '';
    }

    if ((!this.state.currentValues.paypal_email || !validateEmail(this.state.currentValues.paypal_email)) && !this.state.currentValues.donation_details) {
      hasErrors = true;
      validationErrors.payment = 'Please enter a valid PayPal email or Donation Details.';
    } else {
      validationErrors.payment = '';
    }

    this.setState({ validationErrors });

    console.log(!hasErrors);

    return !hasErrors;
  }

  validationError(field) {
    return this.state.validationErrors[field] && <p className='text-danger font-italic'>{this.state.validationErrors[field]}</p>;
  }

  handleSave() {
    if (this.validateForm()) {
      this.setState({
        errorFound: false,
        saving: true,
      });

      Bugsnag.leaveBreadcrumb('Advisor Attempting to save about Data: ' + JSON.stringify({
        variables: this.state.currentValues,
      }, null, 2));

      this.props.SubmitAboutData({
        variables: this.state.currentValues,
      }).then(({ data }) => {
        Bugsnag.leaveBreadcrumb('Succesfully Saved Advisor About Data: ', JSON.stringify(data, null, 2));
        window.onbeforeunload = null;

        this.setState({
          saving: false,
          changeMade: false,
          errorFound: false,
          initialValues: this.state.currentValues,
          customButtonMessage: 'Saved Successfully',
        });

        // if (this.state.currentValues['first_name'] !== this.state.initialValues['first_name']) {
        //   this.props.updateUserFirstName(this.state.currentValues['first_name'] || null); // Update Store
        // }
      }).catch(error => {
        Bugsnag.leaveBreadcrumb('Error while saving Advisor About Data');
        Bugsnag.notifyException(error);
        this.setState({
          saving: false,
          changeMade: true,
          errorFound: true,
          customButtonMessage: 'An error occured. Please try again in a moment or try logging out then back in',
        });
      });
    }
  }

  getButtonText() {
    if (this.state.customButtonMessage !== null) {
      return this.state.customButtonMessage;
    }

    if (this.state.saving) {
      return <Spinner className='spinner--white' />;
    }

    if (this.state.changeMade === false) {
      return 'No Changes made';
    }

    return 'Save';
  }

  saveUploadedPhoto(event) {
    this.props.SubmitAboutData({
      variables: {
        id: this.props.AboutUserData.id,
        avatar: event.target.value,
      }
    })
      .then(
        () => Bugsnag.leaveBreadcrumb('Advisor uplaoded a new photo')
      );
  }

  render() {
    return (
      <div className='ProfileAbout'>
        <Form defaultValue={this.state.initialValues} onChange={this.handleChange}>
          <div className='row'>
            <div className='col-lg'>
              <div className='row'>
                <div className='col-12'>
                  <div className='Form__inputWrap'>
                    <label className='Form__InputLabel'>Profile Photo*</label>
                    <div className='Form__InputInstructions'>
                      <p>Please select a photo that is:</p>
                      <ul>
                        <li>High resolution and color</li>
                        <li>Headshot or upper quarter: clearly showing face (frontal shot)</li>
                        <li>Dimension: Larger than 450X450 px (please see attachment for reference)</li>
                      </ul>
                    </div>
                    <UploadImage name='avatar' onUpload={this.saveUploadedPhoto} ButtonText='Browse Photo' />
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-12'>
                  <div className='Form__LineBreak' />
                </div>
              </div>
            </div>
            <div className='col-lg'>
              <div className='Form__inputWrap'>
                <label htmlFor='Form__FirstName' className='Form__InputLabel'>First Name</label><sup className='text-danger font-weight-bold'> *</sup>
                <input id='Form__FirstName' type='text' name='first_name' className='Form__Input' />
                {this.validationError('first_name')}
              </div>
              <div className='Form__inputWrap'>
                <label htmlFor='Form__LastName' className='Form__InputLabel'>Last Name</label><sup className='text-danger font-weight-bold'> *</sup>
                <span className='Form__InputSubLabel'>Only first initial will be public</span>
                <input id='Form__LastName' type='text' name='last_name' className='Form__Input' />
                {this.validationError('last_name')}
              </div>
              <div className='Form__inputWrap'>
                <label htmlFor='Form__PhoneNumber' className='Form__InputLabel'>Mobile Phone Number</label><sup className='text-danger font-weight-bold'> *</sup>
                <span className='Form__InputSubLabel'>Not visible for public</span><br />
                <span style={{ fontSize: '.8em' }}>We will text you very selectively only to notify you of new student advising opportunities. It will never be shared with the students or anyone else.</span>
                <input id='Form__PhoneNumber' type='text' name='phone' className='Form__Input' />
                {this.validationError('phone')}
              </div>
              <div className='Form__inputWrap'>
                <label htmlFor='Form__Email' className='Form__InputLabel'>Email</label><sup className='text-danger font-weight-bold'> *</sup>
                <span className='Form__InputSubLabel'>Not visible for public</span>
                <input id='Form__Email' type='text' name='email' className='Form__Input' />
                {this.validationError('email')}
              </div>
              <div className='Form__inputWrap'>
                <label htmlFor='Form__LinkedIn' className='Form__InputLabel'>LinkedIn Username</label><sup className='text-danger font-weight-bold'> *</sup>
                <input id='Form__LinkedIn' type='text' name='linkedin_username' className='Form__Input' />
              </div>
              <div className='Form__inputWrap'>
                <label htmlFor='Form__Bio' className='Form__InputLabel'>Bio</label><sup className='text-danger font-weight-bold'> *</sup>
                <div className='Form__InputInstructions'>
                  <p>This will be shown to students so they can have an understanding of your background and interests prior to speaking with you.</p>
                </div>
                <LimitedTextArea id='Form__Bio' placeholder={BIOPlaceHolder} name='biography' className='Form__Input' rows={5} characterLimit={600} />
                {this.validationError('biography')}
              </div>
              <div className='row'>
                <div className='col-12'>
                  <div className='Form__LineBreak' />
                </div>
              </div>
              <div className='Form__inputWrap'>
                <h6>Please complete one of these two fields, so we know how to compensate you for coaching sessions</h6>
                {this.validationError('payment')}
                <h6>For receiving payments, please fill in:</h6>
                <label htmlFor='Form__PaypalEmail' className='Form__InputLabel'>Paypal Email</label>
                <span className='Form__InputSubLabel'>Not visible for public</span>
                <input id='Form__PaypalEmail' type='text' name='paypal_email' className='Form__Input' />
              </div>
              <div className='Form__inputWrap'>
                <h6>Alternatively, fill in:</h6>
                <label htmlFor='Form__DonationDetails' className='Form__InputLabel'>Donation Details</label>
                <input id='Form__DonationDetails' type='text' name='donation_details' className='Form__Input' />
              </div>
            </div>
          </div>
        </Form>
        <button disabled={this.state.changeMade === false && this.state.saving === false} onClick={this.handleSave}
          className='ProfileAbout__button' style={(this.state.errorFound === false) ? {} : { background: '#e85959' }}>
          {this.getButtonText()}
        </button>
      </div>
    );
  }
};

const mapDispatchToProps = {
  updateUserFirstName: updateName,
};

const mapStateToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(About));



// WEBPACK FOOTER //
// ./src/routes/advisor/routes/Profile/routes/About/components/About/index.js